import { CheckboxField } from '../fields/checkboxField';
import { RadioButtonsField } from '../fields/radioButtonsField';
import { SelectField } from '../fields/selectField';
import { TextField } from '../fields/textField';
import { FormElement } from '../formElement';
import { FormStep } from '../formStep';
import { MeasuringConceptOperatingModeType } from '../shared/measuringConceptsOperatingModeType';
import { MeasuringPointOperationType } from '../shared/measuringPointOperationType';
import { SupplyConceptType } from '../shared/supplyConceptType';
import { TransferMeterType } from '../shared/transferMeterType';
import { WithOptional } from '../utility';

type ConfigProps = WithOptional<MeasuringConceptsFormStep, keyof FormStep>;

export class MeasuringConceptsFormStep extends FormStep {
    public readonly operatingMode: SelectField<
        MeasuringConceptOperatingModeType
    >;
    public readonly operatingModeStorage: SelectField<
        MeasuringConceptOperatingModeType
    >;
    public readonly fullInfeedBonusHeadline: FormElement;
    public readonly fullInfeedBonus: CheckboxField;
    public readonly measuringPointOperatorInfo: FormElement;
    public readonly measuringPointOperation: RadioButtonsField<
        MeasuringPointOperationType
    >;
    public readonly meterNumber: TextField;
    public readonly measuringPointOperator: SelectField<string>;
    public readonly priceSheetMeasuringPointOperation: FormElement;
    public readonly specialSupplyConcept: CheckboxField;
    public readonly specialSupplyConceptInfo: FormElement;
    public readonly specialSupplyConceptAcknowledgement: CheckboxField;
    public readonly supplyConceptType: RadioButtonsField<SupplyConceptType>;
    public readonly transferMeterType: RadioButtonsField<TransferMeterType>;
    public readonly measuringPointOperationInfoEwe: FormElement;
    public readonly measuringPointOperationInfoOther: FormElement;
    public readonly minorConsumptionAllocation: CheckboxField;
    public readonly noExtraConsumption: CheckboxField;
    public readonly operatorIdentityMatch: CheckboxField;
    public readonly additionalMeterNumber: TextField;
    public readonly selfGenerationQuantity: TextField;
    public readonly selfSupplyQuantity: TextField;
    public readonly remainingElectricityInfo: FormElement;
    public readonly storageHeadline: FormElement;

    constructor(config: ConfigProps) {
        super(config);
        this.operatingMode = config.operatingMode;
        this.operatingModeStorage = config.operatingModeStorage;
        this.fullInfeedBonusHeadline = config.fullInfeedBonusHeadline;
        this.fullInfeedBonus = config.fullInfeedBonus;
        this.measuringPointOperatorInfo = config.measuringPointOperatorInfo;
        this.measuringPointOperation = config.measuringPointOperation;
        this.meterNumber = config.meterNumber;
        this.measuringPointOperator = config.measuringPointOperator;
        this.priceSheetMeasuringPointOperation =
            config.priceSheetMeasuringPointOperation;
        this.specialSupplyConcept = config.specialSupplyConcept;
        this.specialSupplyConceptInfo = config.specialSupplyConceptInfo;
        this.specialSupplyConceptAcknowledgement =
            config.specialSupplyConceptAcknowledgement;
        this.supplyConceptType = config.supplyConceptType;
        this.transferMeterType = config.transferMeterType;
        this.measuringPointOperationInfoEwe =
            config.measuringPointOperationInfoEwe;
        this.measuringPointOperationInfoOther =
            config.measuringPointOperationInfoOther;
        this.minorConsumptionAllocation = config.minorConsumptionAllocation;
        this.noExtraConsumption = config.noExtraConsumption;
        this.operatorIdentityMatch = config.operatorIdentityMatch;
        this.additionalMeterNumber = config.additionalMeterNumber;
        this.selfGenerationQuantity = config.selfGenerationQuantity;
        this.selfSupplyQuantity = config.selfSupplyQuantity;
        this.remainingElectricityInfo = config.remainingElectricityInfo;
        this.storageHeadline = config.storageHeadline;
    }
}
